import React from 'react'
import PropTypes from 'prop-types'
import qs from 'query-string'
import clsx from 'clsx'
import { useHistory } from 'react-router-dom'
import { ArrowUpRight as ArrowUpRightIcon } from 'react-feather'
import { IconButton, Tooltip } from '@material-ui/core'

import usePermissions from 'hooks/usePermissions'

import { routes } from 'Routes'
import useStyles from './styles'
import constants from 'constants/index'

const DocumentListShortcut = ({ privacyPolicyId, discreet = false }) => {
  const { PRIVACY_POLICIES } = constants.permissions

  const classes = useStyles()
  const history = useHistory()
  const { permitted } = usePermissions()

  // Sem permissão de listar documentos o atalho levaria a uma tela que o usuário não pode ver.
  if (!privacyPolicyId || !permitted(PRIVACY_POLICIES.LIST)) return null

  // A listagem de Documentos monta os filtros a partir da query string (ver useFilter), e o campo
  // "Identificador" filtra por id — então basta chegar lá com o id na URL para o documento vir isolado.
  // Sair de uma tela com alterações não salvas é confirmado por quem tem o formulário — o <Prompt> do
  // ActivityManageForm, no caso da atividade. Este componente só navega.
  const handleRedirect = () =>
    history.push({
      pathname: routes.documents.all,
      search: `?${qs.stringify({ id: privacyPolicyId })}`,
    })

  return (
    <Tooltip title="Ver na listagem de documentos">
      <IconButton
        size={discreet ? 'small' : 'medium'}
        className={clsx({ [classes.discreetButton]: discreet })}
        onClick={handleRedirect}
      >
        <ArrowUpRightIcon size={discreet ? 14 : 20} />
      </IconButton>
    </Tooltip>
  )
}

DocumentListShortcut.propTypes = {
  privacyPolicyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  discreet: PropTypes.bool,
}

export default DocumentListShortcut
